<!--
  Created 06.04.2025
  Proposal language selector component for proposal show page.
-->
<template>
  <div
    class="fixed right-0 top-48 z-50 flex"
    :style="'top:' + (8+(4*order)) + 'rem'">
    <div
      class="relative flex size-12 items-center justify-center rounded-bl-lg border border-r-0 bg-amber-50 opacity-50 shadow
        transition-opacity delay-500 duration-500 ease-in-out hover:cursor-pointer hover:opacity-100 hover:transition-none md:rounded-tl-lg"
      :class="{'w-fit':languageSelectorOpen}"
      :title="'Click to change language'">
      <div
        class="flex h-9 w-full flex-row justify-center space-x-1.5 px-1 pb-1 pt-1.5"
        :class="{'px-4':languageSelectorOpen}">
        <img
          v-if="languages"
          :src="languages[currentLanguage]?.flag"
          alt="Language flag."
          :title="languageSelectorOpen ? `Click to close selector and keep ${languages[currentLanguage]?.name} as selected langauge` : `Click to get a list of available languages to switch to`"
          class="h-4 w-6 shrink-0 cursor-pointer self-center rounded-sm object-cover"
          @click="languageSelectorOpen=!languageSelectorOpen">
        <template v-if="languageSelectorOpen">
          <span class="text-gray-300">|</span>
          <img
            v-for="language in languagesFiltered"
            :key="language.id"
            :src="language.flag"
            :alt="`${language.name} language flag.`"
            :title="`Click to change the language to ${language.name}`"
            class="h-4 w-6 shrink-0 cursor-pointer self-center rounded-sm object-cover"
            @click="setCurrentLanguage(language.id); languageSelectorOpen=false;">
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
/* local */
import {
  computed,
  ref, useAttrs,
} from 'vue';
import {
  getCurrentLanguage, setCurrentLanguage,
} from '@/utils';

/* *********************************************************************
 * Page declarations
 * ****************************************************************** */

defineProps({
  order: {
    type: Number,
    required: false,
    default: 4,
  },
});

const {
  languages,
} = useAttrs();

const currentLanguage = computed(() => getCurrentLanguage());

const languageSelectorOpen = ref(false);

const languagesFiltered = computed(() => Object.values(languages).filter((language) => language.id !== currentLanguage.value));

</script>
